export default "__VITE_ASSET__rF$pEWH7__"